import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { RatioOptions, UndefinedOption } from '@df/ui/atomic/atomic-options';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { TButtonStyles, buttonStylesOptions } from '../../common/buttons/button-style/button-style.component';
import { NTextComponent } from '../../common/text/text.component';

export namespace NCmsEditorial {
    export interface IComponentData extends NICmsContentComponent.IData {
        //Text
        textPosition: string;
        //Video&Image
        ratio: string;
        videoProvider?: 'youtube' | 'vimeo';
        videoId?: string;
        videoAutoplay: boolean;
        videoBackground: boolean;
        backgroundImage?: string;
    }
}

@ICmsComponent<CmsEditorialComponent>({
    id: 'editorial',
    name: 'Editorial',
    image: '/common/cms/video-component.png',
    tags: ['video', 'image', 'editorial'],
    isAdvanced: true,
    fields: [
        // Text
        <NICmsContentField.IChoiceField>{
            key: 'textPosition',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text position',
            options: [
                { key: 'right', title: 'Right' },
                { key: 'left', title: 'Left' }
            ],
            description: 'Only for desktop',
            default: 'right',
            required: true
        },
        ...NTextComponent.getFields(false, true),
        // Video&Image
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-video',
            title: 'Video'
        },
        <NICmsContentField.IChoiceField>{
            key: 'ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Ratio',
            options: RatioOptions,
            description: 'Proportions width x height',
            default: 'ratio-2-1',
            required: true
        },
        <NICmsContentField.IChoiceField>{
            key: 'videoProvider',
            type: NICmsContentField.EFieldType.choice,
            title: 'Video Provider',
            options: [
                ...UndefinedOption,
                {
                    key: 'youtube',
                    title: 'YouTube'
                },
                {
                    key: 'vimeo',
                    title: 'Vimeo'
                }
            ],
            description: 'Choose a video provider'
        },
        {
            key: 'videoId',
            type: NICmsContentField.EFieldType.text,
            title: 'ID or URL',
            description: 'Video ID or URL',
            default: ''
        },
        {
            key: 'videoBackground',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Background Mode',
            default: true,
            required: true
        },
        {
            key: 'videoAutoplay',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Autoplay',
            default: true,
            required: true,
            canShow: (data: NCmsEditorial.IComponentData) => !data.videoBackground
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-image',
            title: 'Background image'
        },
        {
            key: 'backgroundImage',
            type: NICmsContentField.EFieldType.image,
            title: 'Background image',
            default: undefined
        },
        NICmsContentComponent.backgroundField
    ],
    priority: 40
})
@Component({
    selector: 'cms-editorial',
    templateUrl: './cms-editorial.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsEditorialComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsEditorial.IComponentData;
}
